import { memo } from 'react';
import type { FeedPost } from '../model';
import { FriendItemAddedCard } from './FriendItemAddedCard';
import { FavoriteWishlistUpdatedCard } from './FavoriteWishlistUpdatedCard';

interface FeedPostCardProps {
  post: FeedPost;
  onItemClick: (wishlistId: string, itemId: string) => void;
  onUserClick: (userId: string) => void;
}

/**
 * Exhaustive check для discriminated union
 * Гарантирует что мы обработали все возможные типы
 */
function assertNever(x: never): never {
  throw new Error(`Unexpected post type: ${JSON.stringify(x)}`);
}

/**
 * Композитный компонент карточки поста в ленте
 * Выбирает правильную карточку в зависимости от типа поста
 * Использует discriminated union с exhaustive check для type safety
 */
export const FeedPostCard = memo(function FeedPostCard({
  post,
  onItemClick,
  onUserClick,
}: FeedPostCardProps): JSX.Element {
  switch (post.type) {
    case 'friend_item_added':
      return (
        <FriendItemAddedCard
          post={post}
          onItemClick={onItemClick}
          onUserClick={onUserClick}
        />
      );

    case 'favorite_wishlist_updated':
      return (
        <FavoriteWishlistUpdatedCard
          post={post}
          onItemClick={onItemClick}
          onUserClick={onUserClick}
        />
      );

    default:
      return assertNever(post);
  }
});